module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/media/opponent-khabib-nurmagomedov-desktop.519c2a90.mp4";